import { Component, OnInit } from '@angular/core';
import { ErroresHandler } from 'src/app/base/tools/handler/error.handler';
import { Curso } from 'src/app/project/interfaces/curso';
import { Modulo } from 'src/app/project/interfaces/modulo';
import { CursosService } from 'src/app/project/services/cursos.service';
import { SessionService } from 'src/app/project/services/session.service';

@Component({
  selector: 'app-cursos',
  templateUrl: './cursos.component.html',
  styleUrls: ['./cursos.component.css']
})
export class CursosComponent implements OnInit {

  public cursos: Curso[];
  public loading: boolean = true;
  public loadingAccesoCurso: boolean = false;
  public tiempoActual: number = new Date().getTime();


  getAyudaEstadoCurso(estado){
    let mensaje = 'No hay información';
    switch(estado){
      case 'ACTIVO':
        mensaje = 'Puedes acceder al curso las veces que quieras presionando el botón ir al curso.';
        break;
      case 'EN ESPERA':
        mensaje = 'El curso se habilitará una vez se confirme o cuando se acerque la fecha de inicio.';
        break;
      case 'INACTIVO':
        mensaje = 'Es posible que el curso no inicie aún, o bien que haya finalizado.';
        break;
    }
    return mensaje; 
  }

  constructor(
    private cursosService: CursosService,
    private sessionService: SessionService,
    private erroresHandler: ErroresHandler
  ) { 
  }

  public tipoCursos: any[] = [
    {label: 'Ver todo', value: null},
    {label: 'GRATUITO', value: 'GRATUITO'},
    {label: 'PRIVADO', value: 'PRIVADO'},
    {label: 'DE PAGO', value: 'DE PAGO'},
    {label: 'DIPLOMADO', value: 'DIPLOMADO'}
  ];

  public modalidades: any[] = [
    {label: 'Ver todo', value: null},
    {label: 'VIRTUAL', value: 'VIRTUAL'},
    {label: 'PRESENCIAL', value: 'PRESENCIAL'},
    {label: 'HIBRIDO', value: 'HIBRIDO'}
  ];

  public estados: any[] = [
    {label: 'Ver todo', value: null},
    {label: 'Aceptado', value: 'Aceptado'},
    {label: 'En Revisión', value: 'En Revisión'},
    {label: 'Rechazado', value: 'Rechazada'},
    {label: 'Pendiente de pago', value: 'Pendiente de pago'}
  ];

  public ordenar: any[] = [
    {label: 'Nombre A-Z', value: 'az'},
    {label: 'Nombre Z-A', value: 'za'},
    {label: 'Primeras postulaciones', value: 'fechaasc'},
    {label: 'Últimas postulaciones', value: 'fechadesc'}
  ];


  public cursosFiltrados = [];
  public filter = {
    modalidad: null, 
    tipoCurso: null,
    estado: null
  };


  filtrarCursos(){

    this.loading = true;

      this.cursosFiltrados = this.cursos.filter(curso => 

        (this.filter.modalidad ? curso.modalidad == this.filter.modalidad : true) 
        && 
        (this.filter.tipoCurso ? curso.tipoCurso == this.filter.tipoCurso : true)
        && 
        (this.filter.estado ? curso.estado == this.filter.estado : true)
      )

      
    setTimeout(() => {
      this.loading = false
    }, 500);
  }

  ordenarCursos(event){
    this.loading = true;
    switch(event){
      case 'az':
        this.cursosFiltrados.sort(function (a, b) {
          if (a.nombre > b.nombre) {
            return 1;
          }
          if (a.nombre < b.nombre) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
        break;
      case 'za':
        this.cursosFiltrados.sort(function (a, b) {
          if (a.nombre < b.nombre) {
            return 1;
          }
          if (a.nombre > b.nombre) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
        break;
      case 'fechaasc':
        this.cursosFiltrados.sort(function (a, b) {
          return new Date(a.fechaInicio).getTime() - new Date(b.fechaInicio).getTime()
        })
        break;
      case 'fechadesc':
        this.cursosFiltrados.sort(function (a, b) {
          return new Date(b.fechaInicio).getTime() - new Date(a.fechaInicio).getTime()
        })  
        break;
    }
    
    setTimeout(() => {
      this.loading = false
    }, 500);
    
  }

  
  ngOnInit(): void {
    this.cursosService.obtenerCursosUsuario().then( (cursos: Curso[]) => {
      this.cursos = cursos;
      this.filtrarCursos();
      this.ordenarCursos('fechadesc');
      
    }).catch(e => {
      this.erroresHandler.processError(
          e,
          'alert',
          'Error al obtener cursos, intente más tarde',
          'Error'
      );
  });

  }

}
